import { Button } from '@/components/Button'
import { BRANDSIDE_SERVICE_URL } from '@/config/site'
import { Icon } from '@/icons'
import cn from 'classnames'
import { FC } from 'react'
import styles from './RegistrationPrompt.module.scss'

interface RegistrationPromptProps {
  className?: string
}
export const RegistrationPrompt: FC<RegistrationPromptProps> = ({
  className,
}) => {
  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.title}>
        Еще больше товарных знаков в вашем личном кабинете. Зарегистрируйтесь,
        чтобы получить больше возможностей!
      </div>
      <Button
        href={BRANDSIDE_SERVICE_URL ?? ''}
        target="_blank"
        className={styles.button}
      >
        Зарегистрироваться
        <Icon name="arrowRight" className={styles.arrow} />
      </Button>
    </div>
  )
}
